import {CAD_3D_DATA_PACKAGE, parsePackageVersionTags, UNRESOLVED_VERSION} from './packageVersionTags';

// What the library reads off the global. @ergeon/cad declares the real shape, but the
// version installed here has no such field yet, so the write is typed against a local one.
type Cad3dConfig = {texturesVersion?: string};

export const resolveTexturesVersion = (raw?: string): string | undefined => {
  const version = parsePackageVersionTags(raw)[CAD_3D_DATA_PACKAGE];
  return version && version !== UNRESOLVED_VERSION ? version : undefined;
};

/**
 * Hands @ergeon/cad the resolved version of the 3d-data this build serves; the library keys
 * its IndexedDB texture cache on it, and without one it clears that cache before every image.
 */
export const configureCad3d = (): void => {
  const texturesVersion = resolveTexturesVersion(import.meta.env.ERGEON_PACKAGE_VERSIONS);
  if (!texturesVersion) {
    // Loud on purpose: a texture cache that disables itself looks like nothing at all from
    // the outside, and warn is the one console level production builds keep.
    console.warn(
      `cad texture cache disabled: no resolved @ergeon/${CAD_3D_DATA_PACKAGE} version in the build-time map`,
    );
    return;
  }
  const host = globalThis as unknown as {config3d?: Cad3dConfig};
  host.config3d = {...host.config3d, texturesVersion};
};
